import { ResourceOptions } from 'react-admin';
import { MdOutlineBalance } from 'react-icons/md';

import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.xbitRelayProviderAudit;
export { XBIT_RELAY_PROVIDER_AUDIT_PERMISSION_RESOURCE } from './constants';
export const icon = MdOutlineBalance;
export const options: ResourceOptions = {
  label: 'module.xbitRelayProviderAudit.title',
};
